<script>
  import DatePickerModal from "../Modals/DatePickerModal.svelte";
  import { createDatePickerContext } from "./context.svelte.js";
  import DatePickerSelector from "./DatePickerComponents/DatePickerSelector.svelte";

  let {
    initialDate = null, // TODO deprecate with onChange - one component uses this
    allowFuture = true,
    allowPast = true,
    includeTime = false,
    placeholder = "No date selected",
    label = "Select date",
    disabled = false,
    selectedDate = $bindable(initialDate),
    reset = $bindable(),
    customButtonText = undefined,
    modalTitle = undefined,
    onApply = undefined,
    onCancel = undefined,
    showModal = false,
  } = $props();

  const datePickerContext = createDatePickerContext({
    getSelectedDate: () => selectedDate,
    setSelectedDate: (date) => {
      selectedDate = date;
    },
    selectedDate,
    allowFuture,
    allowPast,
    includeTime,
    customButtonText,
    modalTitle,
    onApply,
    onCancel,
    showModal,
  });

  reset = () => {
    datePickerContext.reset();
  };

  const onclose = () => {
    if (datePickerContext.onCancel) {
      // Call onCancel if provided
      datePickerContext.onCancel();
    } else datePickerContext.showModal = false;
  };
</script>

{#if datePickerContext.showModal}
  <DatePickerModal {onclose} />
{:else if !onApply}
  <DatePickerSelector {label} {placeholder} {disabled} />
{/if}
